import { useOauth2Config } from './use-oauth2-config.hook';

export function useOauth2Actions() {
  const { config } = useOauth2Config();

  const buildUrl = (endpoint: string) => `${config.authApiUrl}/${endpoint}?redirect_uri=${config.authApiOauth2RedirectUrl}`;
  const replaceUrl = (url: string) => window.location.href = url;

  const loginUri = buildUrl(config.authApiOauth2Login);
  const logoutUri = buildUrl(config.authApiOauth2Logout);

  return {
    login: () => replaceUrl(loginUri),
    logout: () => replaceUrl(logoutUri),
    logoutWithRedirect: () => replaceUrl(`${config.authApiUrl}/${config.authApiOauth2Logout}?redirect_uri=${window.location.origin}/deconnexion`)
  };
}